import request from '@/utils/request'

// 获取协议详情（含默认兜底）
export function getAgreementDetail(docType) {
  return request({
    url: '/api/frontend/agreement/detail',
    method: 'get',
    params: { docType }
  })
}

// 获取已绑定的协议模版（原有接口）
export function getAgreementTemplate(typeCode) {
  return request({
    url: '/api/frontend/agreement/template',
    method: 'get',
    params: { typeCode }
  })
}
